module.exports = require('./lib/internals')



//////////////////
// WEBPACK FOOTER
// ./node_modules/@sanity/block-content-to-hyperscript/internals.js
// module id = 257
// module chunks = 0